import type { FlatSurface } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { componentRectOnPhoto, type PhotoDimensions } from '@/entities/edit-area';

interface FlatSurfaceOverlayProps {
  readonly surface: FlatSurface;
  readonly photoSize: PhotoDimensions;
}

/**
 * 평면 표면 틀 — 안내용 점선 사각형(윤곽이 없으면 옅게 채운다). 포인터를 받지 않는다: 표면은 사진 위에서 고르거나
 * 고치지 않고 '다시 추출하기'·'표면 삭제'(고급 수치 칸)로만 바꾼다.
 */
export const FlatSurfaceOverlay = ({
  surface,
  photoSize,
}: FlatSurfaceOverlayProps): ReactElement => {
  const rect = componentRectOnPhoto(surface, photoSize, surface.realSize, { xMm: 0, yMm: 0 });
  return (
    <rect
      {...rect}
      fill={surface.outline ? 'none' : '#64748b10'}
      stroke="#64748b"
      strokeDasharray="4 4"
      strokeWidth={1.5}
      vectorEffect="non-scaling-stroke"
      pointerEvents="none"
      data-testid={`surface-frame-${surface.id}`}
    />
  );
};
